import React from 'react';
import { MaskRestrictedText } from '_src/components';

export default [
  {
    title: 'Permit rec. date',
    dataIndex: 'permitRecDate',
    sorter: true
  },
  {
    title: 'Branch name',
    dataIndex: 'branchName',
    sorter: true
  },
  {
    title: 'Date class begins',
    dataIndex: 'dateClassBegins'
  },
  {
    title: 'Branch state code',
    dataIndex: 'branchStateCode'
  },
  {
    title: 'Location',
    dataIndex: 'location'
  },
  {
    title: 'First name',
    dataIndex: 'firstName',
    key: 'firstName',
    render: (_, { firstName }) => (
      <div>{firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase()}</div>
    ),
    sorter: true
  },

  {
    title: 'Last name',
    dataIndex: 'lastName',
    key: 'lastName',
    render: (_, { lastName }) => (
      <div> {lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase()}</div>
    ),
    sorter: true
  },

  {
    title: 'Birthdate',
    dataIndex: 'birthdate',
    render: _ => <MaskRestrictedText text={_} />
  },
  {
    title: 'License',
    dataIndex: 'studentNumber',
    width: 200,
    render: _ => <MaskRestrictedText text={_} />
  },
  {
    title: 'Endorsement code',
    dataIndex: 'endorsementCode'
  },
  {
    title: 'Completion date',
    dataIndex: 'completionDate'
  },
  {
    title: 'Contact number',
    dataIndex: 'contactNumber'
  },
  {
    title: 'Sponsor',
    dataIndex: 'sponsor',
    render: _ => <MaskRestrictedText text={_} />,
    sorter: true,
    width: 200
  },
  {
    title: 'FMCSA Location  Id',
    dataIndex: 'fmcsaLocationId',
    width: 300
  },
  {
    title: 'Status',
    dataIndex: 'status',
    sorter: true
  },
  {
    title: 'BTW—Public Road',
    dataIndex: 'road'
  },
  {
    title: 'BTW—Range',
    dataIndex: 'skills'
  },
  {
    title: 'Score',
    dataIndex: 'score'
  }
];
